<template>
    <div>
        <div>
            <v-btn
                :class="{'white--text primary': this.showAssets}"
                width="50%"
                @click="() => this.showAssets = true">Assets</v-btn>
            <v-btn
                :class="{'white--text primary': !this.showAssets}"
                width="50%"
                @click="() => this.showAssets = false">Liabilities</v-btn>
        </div>
        <div>
        <div><aqumulate-modal style="text-align: right"/></div>
        <div v-if="showAssets">
            <account-card
                :account-overview-ables="banking"
                title="Banking">
                <template v-slot:account-detail="{ account }">
                    <div><b>Individual :</b> {{ account.ownerLabel }}</div>
                    <div><b>Company :</b> {{ account.company_name }}</div>
                    <div><b>Type of Account :</b> {{ account.company_name }}</div>
                    <div v-if="account.account_number"><b>Account Number :</b> {{ account.account_number }}</div>
                    <div><b>Value :</b> {{ account.value | money }} </div>
                </template>
            </account-card>
            <account-card
                :account-overview-ables="nonTaxQualifed"
                title="Investment">
                <template v-slot:account-detail="{ account }">
                    <div><b>Individual :</b> {{ account.ownerLabel }}</div>
                    <div><b>Company :</b> {{ account.company_name }}</div>
                    <div><b>Type of Account :</b> {{ account.company_name }}</div>
                    <div v-if="account.account_number"><b>Account Number :</b> {{ account.account_number }}</div>
                    <div><b>Value :</b> {{ account.value | money }} </div>
                </template>
            </account-card>
            <account-card
                :account-overview-ables="taxQualifed"
                title="Retirement">
                <template v-slot:account-detail="{ account }">
                    <div><b>Individual :</b> {{ account.ownerLabel }}</div>
                    <div><b>Company :</b> {{ account.company_name }}</div>
                    <div><b>Type of Account :</b> {{ account.company_name }}</div>
                    <div v-if="account.account_number"><b>Account Number :</b> {{ account.account_number }}</div>
                    <div><b>Value :</b> {{ account.value | money }} </div>
                </template>
            </account-card>
            <account-card
                :account-overview-ables="insurances"
                title="Insurance Cash Value">
                <template v-slot:account-detail="{ account }">
                    <div><b>Individual :</b> {{ account.ownerLabel }}</div>
                    <div><b>Carrier :</b> {{ account.carrier }}</div>
                    <div><b>Type:</b> {{ account.typeLabel }}</div>
                    <div><b>Death Benefit :</b> {{ account.death_benefit | money}}</div>
                    <div><b>Value :</b> {{ account.cash_value | money }} </div>
                    <div><b>Policy Number :</b> {{ account.cash_value | money }}</div>
                </template>
            </account-card>
        </div>
        <div v-else>
            <account-card
                :account-overview-ables="liabilities"
                title="Liability">
                <template v-slot:account-detail="{ account }">
                    <div><b>Name :</b> {{ account.name }}</div>
                    <div v-if="account.account_number"><b>Account Number :</b> {{ account.account_number }}</div>
                    <div><b>Amount Owed:</b> {{ account.amount_owed | money }}</div>
                    <div><b>Monthly Payment :</b> {{ account.monthly_payment | money }}</div>
                </template>
            </account-card>
            <account-card
                :account-overview-ables="properties"
                title="Mortgage">
                <template v-slot:account-detail="{ account }">
                    <div><b>Name :</b> {{ account.name }}</div>
                    <div v-if="account.account_number"><b>Account Number :</b> {{ account.account_number }}</div>
                    <div><b>Style :</b> {{ account.styleLabel }}</div>
                    <div><b>Value:</b> {{ account.amount_owed | money }}</div>
                    <div><b>Mortgage:</b> {{ account.mortgage | money }}</div>
                    <div><b>Payment:</b> {{ account.payment | money }}</div>
                    <div><b>Income:</b> {{ account.income | money }}</div>
                </template>
            </account-card>
        </div>
        </div>
    </div>
</template>
<script>
import AccountCard from "@/components/dashboard/AccountCard";
import AqumulateModal from "@/components/aqumulate/AqumulateModal";
export default {
    components: {
        AccountCard,
        AqumulateModal
    },

    props: {
        taxQualifed: {
            type: Array,
            required: false
        },
        nonTaxQualifed: {
            type: Array,
            required: false
        },
        banking: {
            type: Array,
            required: false
        },
        insurances: {
            type: Array,
            required: false
        },
        liabilities: {
            type: Array,
            required: false
        },
        properties: {
            type: Array,
            required: false
        },
    },

    data() {
        return {
            showAssets: true
        }
    }
}
</script>
